import React from 'react'
import { MonitoringTask } from './monitoring-task'
import classes from './style.module.css'
import { Icon, IconType } from '../../atoms/Icon'
import Button from '../Button'

interface MonitoringListProps {
  tasks: MonitoringTask[]
  onDeleteTask: (id: string) => void
}

const MonitoringList: React.FC<MonitoringListProps> = ({ tasks, onDeleteTask }) => {
  return (
    <div className={classes.list}>
      {tasks.length === 0 ? (
        <p className={classes.noData}>Нет данных</p>
      ) : (
        <table className="table table-hover">
          <thead>
            <tr>
              <th className="text-left">ИНН</th>
              <th className="text-center">Статус</th>
              <th className="text-center" />
            </tr>
          </thead>
          <tbody>
            {tasks.map((task) => {
              const inn = task.data?.['counterparty.inn'] || '—'

              return (
                <tr key={task.id}>
                  <td className="text-left" style={{ textAlign: 'center' }}>
                    {inn}
                  </td>
                  <td className="text-center">
                    <span className={classes.badgeActive}>Активно</span>
                  </td>
                  <td className="text-center">
                    <Button variant="transparent" className={classes.minusIcon} onClick={() => onDeleteTask(task.id)}>
                      <Icon type={IconType.Close} height="1rem" width="1rem" />
                    </Button>
                  </td>
                </tr>
              )
            })}
          </tbody>
        </table>
      )}
    </div>
  )
}

export default MonitoringList
